import ApiService from "@/core/services/api.service";

// action types
export const GET_PRODUCTS_SEARCH = "getProductsSearch";

// mutation types
export const SET_PRODUCTS_ERROR_SEARCH = "setErrorsSearch";
export const SET_PRODUCTS_SEARCH = "setProductsSearch";
export const SET_PRODUCT_LOAD_SEARCH = "setProductLoadSearch";



const state = {
    errors: {},
    products: {},
    load: false,
    product: {},

};

const getters = {
    gettersProductsSearch(state) {
        return state.products;
    },
    errorsProductsSearch(){
        return state.errors;
    },
    getProductLoadSearch(){
        return state.load;
    },
};

const actions = {
    [GET_PRODUCTS_SEARCH](context, data) {
        return new Promise((resolve, reject) => {
            context.commit(SET_PRODUCT_LOAD_SEARCH, true);
            ApiService.post("/products-search", data)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_PRODUCTS_SEARCH, data);
                    context.commit(SET_PRODUCT_LOAD_SEARCH, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_PRODUCTS_ERROR_SEARCH, response.data.errors);
                    context.commit(SET_PRODUCT_LOAD_SEARCH, false);
                });
        });
    }
};

const mutations = {
    [SET_PRODUCTS_ERROR_SEARCH](state, error) {
        state.errors = error;
    },

    [SET_PRODUCTS_SEARCH](state, data) {
        state.products = data.data;

    },

    [SET_PRODUCT_LOAD_SEARCH](state, load) {
        state.load = load;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
